export default {
    send: 'Send',
    couponSendedText: 'Thank you for your participation in our survey!<br><br>You will receive your reward in a few minutes. Please check your notifications in the app.',
    validations: {
        required: 'This field is required.',
        email: 'Please enter a valid {field}.',
        digits: "{field}, {length} rakamdan oluşmalıdır",
        alpha: "{field}, alfabetik karakterlerden oluşmalıdır",
        phoneNumber: "Lütfen geçerli bir telefon numarası giriniz",
        regex: 'Lütfen geçerli bir {field} giriniz',
        length: `{field}, {rule.length} uzunluğunda olmalı`,
        tcNumber: "Girilen Kimlik Numarası geçersiz",
        iban: 'Girilen IBAN geçersiz.',
        isValid: `Bu alanı doldurabilmek için {rule[0]} alanını işaretleyin.`,
        minCharacter: `En az {min} karakter uzunluğunda olmalıdır.`
    },
    contactUs: {
        subject: 'Subject',
        message: 'Message',
        email: 'Email',
        preWrittenMessage: "I want to delete my account because ... ",
        accountDeletion: 'Account Deletion',
    }
}